import { ValueFormatterParams } from 'ag-grid-community';
import moment from 'moment';

import { formatCurrency } from '@app/shared/utils/number.utils';

import { DecimalPlacesUtils } from './decimal-places.utils';

//

const currency = ({ value } :ValueFormatterParams) :string => formatCurrency(value);

const decimalPlaces = ({ value } :ValueFormatterParams) :string =>
  value ? DecimalPlacesUtils.format(value) : '';

const date = (
  params :ValueFormatterParams,
  format :string = 'MMM DD, YYYY',
) :string => {
  if (!params.value) return '';

  return moment(params.value).format(format);
};

//

export const AgGridValueFormatter = {
  CURRENCY: currency,
  DATE: date,
  DECIMAL_PLACES: decimalPlaces,
};
